import Button from "@/components/ui/Button";
import { useAuthContext } from "@/contexts/AuthContext";
import Link from "next/link";
import { useRouter } from "next/navigation";
import React from "react";

interface AuthFooterProps {
  showSignIn?: boolean;
  showSignUp?: boolean;
  showForgetPassword?: boolean;
  showContact?: boolean;
}

const AuthFooter: React.FC<AuthFooterProps> = ({
  showSignIn = true,
  showSignUp = true,
  showForgetPassword = true,
  showContact = true,
}) => {
  const router = useRouter();
  const { refreshUser } = useAuthContext();
  return (
    <div className="w-full max-w-md">
      {showSignIn && (
        <div className="mb-4">
          <Button
            variant="secondary"
            className="w-full"
            onClick={async () => {
              await refreshUser();
              router.push("/");
            }}
            withCaret
          >
            アカウントをお持ちの方はこちら
          </Button>
        </div>
      )}
      {showSignUp && (
        <div className="mb-4">
          <Button
            variant="secondary"
            className="w-full"
            onClick={async () => {
              await refreshUser();
              router.push("/signup");
            }}
            withCaret
          >
            新規登録はこちら
          </Button>
        </div>
      )}
      {(showForgetPassword || showContact) && (
        <div className="flex justify-between">
          {showForgetPassword ? (
            <Link href="/forgot-password" className="normal-link">
              パスワードを忘れた方
            </Link>
          ) : (
            <div />
          )}
          {showContact ? (
            <Link href="/contact" className="normal-link">
              お問い合わせ
            </Link>
          ) : (
            <div />
          )}
        </div>
      )}
    </div>
  );
};

export default AuthFooter;
